module.exports = __webpack_public_path__ + "img/somalia.6065671b.svg";